import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DocumentationComponent } from './documentation/documentation.component';


const routes: Routes = [
    { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
    { path: 'documentation', component: DocumentationComponent },
    { path: 'estamp', loadChildren: () => import('./e-stamp/e-stamp.module').then(m => m.EStampModule) },
    { path: 'esign', loadChildren: () => import('./e-sign/e-sign.module').then(m => m.ESignModule) },


];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class PagesRoutingModule { }
